import React from "react";
import "./Sidebar.css";
import { getCurrentUser, hasAnyRole, hasRole } from "../services/AuthenticationService";

const roleLabel = () => {
  if (hasRole("ROLE_SUPER_ADMIN")) return "Super admin";
  if (hasRole("ROLE_ADMIN")) return "Admin";
  if (hasRole("ROLE_MANAGER")) return "Manager";
  if (hasRole("ROLE_ADS_ADMIN")) return "Ads admin";
  return "Utilisateur";
};

const activeKeyFor = (choosedMenu) => {
  const path = choosedMenu.map((e) => e.label).join(",");
  if (path === "Home,Dashboard") return "dashboard";
  if (path === "Home,Management,Controller") return "controllers";
  if (path === "Home,Management,PointOfSales") return "pos";
  if (path === "Home,Management,Users") return "users";
  if (path === "Home,Management,Commands") return "commands";
  if (path === "Home,Advertisement,Resources") return "ads";
  return "";
};

const icon = (paths) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {paths}
  </svg>
);

const Icons = {
  dashboard: icon(<><path d="M3 10.5 12 3l9 7.5" /><path d="M5 9.5V20a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V9.5" /></>),
  controllers: icon(<><rect x="4" y="4" width="16" height="16" rx="3" /><path d="M9 9h6v6H9z" /></>),
  pos: icon(<><path d="M12 21s7-6.1 7-11a7 7 0 1 0-14 0c0 4.9 7 11 7 11z" /><circle cx="12" cy="10" r="2.3" /></>),
  users: icon(<><circle cx="9" cy="8" r="3" /><path d="M3.5 20a5.5 5.5 0 0 1 11 0" /><circle cx="17" cy="9" r="2.3" /><path d="M15.3 13.1A4.5 4.5 0 0 1 20.5 17.5" /></>),
  commands: icon(<><rect x="3" y="4" width="18" height="16" rx="2.5" /><path d="M7 9l3 3-3 3" /><path d="M12 15h5" /></>),
  ads: icon(<><rect x="3" y="4" width="18" height="16" rx="2.5" /><circle cx="8.5" cy="9.5" r="1.6" /><path d="M21 16l-5.5-5.5L7 19" /></>),
};

const NavItem = ({ icon: navIcon, label, active, onClick }) => (
  <button
    type="button"
    className={`sidebar-item${active ? " sidebar-item-active" : ""}`}
    aria-current={active ? "page" : undefined}
    onClick={onClick}
  >
    {navIcon}
    <span>{label}</span>
  </button>
);

const Sidebar = ({ chooseMenu, choosedMenu, onHome }) => {
  const active = activeKeyFor(choosedMenu);

  const showManagement = hasAnyRole("ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_MANAGER");
  const showUsers = hasAnyRole("ROLE_SUPER_ADMIN", "ROLE_ADMIN");
  const showAds = hasAnyRole("ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_ADS_ADMIN");

  const username = localStorage.getItem("user") || getCurrentUser()?.sub || "";
  const initials = username.slice(0, 2).toUpperCase() || "?";

  return (
    <nav className="sidebar" aria-label="Navigation principale">
      <button type="button" className="sidebar-logo" onClick={onHome}>
        <img src="SRCS.png" alt="" />
        <span>SRCS</span>
      </button>

      <NavItem
        icon={Icons.dashboard}
        label="Tableau de bord"
        active={active === "dashboard"}
        onClick={() => chooseMenu("Dashboard")}
      />

      {showManagement && (
        <>
          <div className="sidebar-section-label">GESTION</div>
          <NavItem
            icon={Icons.controllers}
            label="Contrôleurs"
            active={active === "controllers"}
            onClick={() => chooseMenu("Management,Controller")}
          />
          <NavItem
            icon={Icons.pos}
            label="Points de vente"
            active={active === "pos"}
            onClick={() => chooseMenu("Management,PointOfSales")}
          />
          {showUsers && (
            <NavItem
              icon={Icons.users}
              label="Utilisateurs"
              active={active === "users"}
              onClick={() => chooseMenu("Management,Users")}
            />
          )}
          <NavItem
            icon={Icons.commands}
            label="Commandes"
            active={active === "commands"}
            onClick={() => chooseMenu("Management,Commands")}
          />
        </>
      )}

      {showAds && (
        <>
          <div className="sidebar-section-label">PUBLICITÉ</div>
          <NavItem
            icon={Icons.ads}
            label="Ressources"
            active={active === "ads"}
            onClick={() => chooseMenu("Advertisement,Resources")}
          />
        </>
      )}

      <div className="sidebar-spacer"></div>

      {username !== "" && (
        <div className="sidebar-user">
          <div className="sidebar-user-avatar">{initials}</div>
          <div className="sidebar-user-text">
            <span className="sidebar-user-name">{username}</span>
            <span className="sidebar-user-role">{roleLabel()}</span>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Sidebar;
